import { Inject, Injectable, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { Brands, THEME_FILES } from 'src/app/shared/constants/brands.constants';

@Injectable({ providedIn: 'root' })
export class BrandService {
  private style: HTMLLinkElement;
  private currentBrand = Brands.REGUS;

  constructor(
    @Inject(DOCUMENT) private document: Document,
  ) {}

  public applyBrand(theme: Brands, renderer: Renderer2): void {
    this.currentBrand = theme;
    const styleHref = `assets/themes/${THEME_FILES[theme]}`;
    this.style = renderer.createElement('link') as HTMLLinkElement;

    renderer.setProperty(this.style, 'rel', 'stylesheet');
    renderer.setProperty(this.style, 'type', 'text/css');
    renderer.setProperty(this.style, 'href', styleHref);

    renderer.appendChild(this.document.head, this.style);
  }

  public getImageUrl(file: string): string {
    return `assets/images/redesign/${this.currentBrand}/${file}`;
  }

  public getCurrentBrand(): Brands {
    return this.currentBrand;
  }
}
